import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ProjectsService } from '@cosmos/angular/api';
import { ErrorService } from '@cosmos/angular/utils';
import { Project } from '@cosmos/shared';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
    selector: 'cosmos-project-visualization-settings',
    imports: [TranslatePipe, ReactiveFormsModule,
        DividerModule, ButtonModule, CheckboxModule
    ],
    templateUrl: 'project-visualization-settings.component.html'
})

export class ProjectVisualizationSettingsComponent implements OnInit {

    @Input()
    project: Project = null;

    @Output()
    updatedProject = new EventEmitter<Project>();
    
    visualizationConfig;

    constructor(
        private projectsService: ProjectsService,
        private formBuilder: FormBuilder,
        private errorService: ErrorService,
    ) { }

    ngOnInit() {
        this.visualizationConfig = this.formBuilder.group({
            maturity: this.formBuilder.group({
                app: this.project.visualizationConfig?.maturity?.app, 
                report: this.project.visualizationConfig?.maturity?.report
            }),
            maturityThreshold: this.formBuilder.group({
                app: this.project.visualizationConfig?.maturityThreshold?.app, 
                report: this.project.visualizationConfig?.maturityThreshold?.report
            }),
            relativeMaturity: this.formBuilder.group({
                app: this.project.visualizationConfig?.relativeMaturity?.app, 
                report: this.project.visualizationConfig?.relativeMaturity?.report
            }),
            relativeMaturityThreshold: this.formBuilder.group({
                app: this.project.visualizationConfig?.relativeMaturityThreshold?.app, 
                report: this.project.visualizationConfig?.relativeMaturityThreshold?.report
            }),
        });
    }

    updateProject(updateObject) {
        this.projectsService.update([this.project._id, {visualizationConfig: updateObject.value}]).subscribe({
            next: (response) => this.updatedProject.emit(response.body),
            error: (e) => this.errorService.handleError(e)
        });
    }
}